import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const link = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      linkType: "l",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.pesaLinkAccount, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const DeLink = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      linkType: "d",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.pesaLinkAccount, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const PesaLinkService = {
  link,
  DeLink,
};

export default PesaLinkService;
